import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="main-footer text-center text-dark">
        <strong>Copyright © 2024 Maharashtra Legislature Secretariat</strong>
      </footer>
    </div>
  );
};

export default Footer;
